module.exports = __webpack_public_path__ + "img/lot_jefferson.1e0a1399.jpg";